import { BnsnLogoColorWithText } from '@bnsn/ui'
import { Link } from 'react-router'

interface LogoLinkProps {
  href?: string
}

/**
 * LogoLink is a link to the home page with the BNSN logo.
 *

 *
 * @param {LogoLinkProps} props
 */
export const LogoLink = ({ href }: LogoLinkProps) => {
  return (
    <Link to={href ?? '/'} title="BNSN Application - Home Page">
      <BnsnLogoColorWithText height={40} />
    </Link>
  )
}
